import { DCPValueUnitDTO, ExtendedSMSProduct, SMSProduct } from '../models/shared/ocb';

export type EmhEnvironment = 'dev1' | 'dev2' | 'dev3' | 'dev4' | 'int' | 'preprod' | 'prod';
export enum CommerceApiContext {
  OCB = 'OCB',
  FOC = 'FOC',
}

export interface CommerceApiHttpService {
  get<T>(url: string, config?: unknown): Promise<{ data: T }>;
  post<T>(url: string, config?: unknown): Promise<{ data: T }>;
  put<T>(url: string, config?: unknown): Promise<{ data: T }>;
  patch<T>(url: string, config?: unknown): Promise<{ data: T }>;
  delete<T>(url: string, config?: unknown): Promise<{ data: T }>;
}

export interface CommerceApiHttpContext {
  ocb: CommerceApiHttpService;
  foc: CommerceApiHttpService;
  bff?: CommerceApiHttpService;
}

export interface CommerceApiContextHttpServices {
  product: CommerceApiHttpContext;
  search: CommerceApiHttpContext;
  searchFilter: CommerceApiHttpContext;
}

export interface CommerceApiContextOptions {
  context: CommerceApiContext;
  httpServices: CommerceApiContextHttpServices;
}

type HasBffImplemented<TDomain extends keyof CommerceApiContextHttpServices> = {
  isBffEnabled: boolean;
  httpServices: { [domain in TDomain]: Required<CommerceApiHttpContext> };
};

export type CommerceApiProductContext = CommerceApiContextOptions &
  HasBffImplemented<'product'> & {
    i18n: {
      lang: string;
      getTranslationUnitFallback(value: number, key: string, displayName: string): string;
      getTranslationFallback(key: string, displayName: string): string;
      getEngineDescription(
        combustionPower: DCPValueUnitDTO,
        combustionPowerSecondary: DCPValueUnitDTO,
        electricPower: DCPValueUnitDTO,
        electricPowerSecondary: DCPValueUnitDTO,
      ): string;
    };
    mapVehicleModel: (data: SMSProduct) => ExtendedSMSProduct;
  };
